(function(){
  function initGallery(root){
    if (!root || root.dataset.thumbFallbackInit === '1') return;
    root.dataset.thumbFallbackInit = '1';

    var main = root.querySelector('[data-image-gallery-main]');
    var thumbsWrap = root.querySelector('.productView-for');
    if(!main || !thumbsWrap) return;

    var slides = Array.from(main.querySelectorAll('.productView-image'));
    if(!slides.length) return;

    function getIndexFromClick(target){
      var link = target.closest('.productView-thumbnail-link');
      if(!link) return null;

      // Si existe data-thumb-index, lo usa (si no, calcula por posición)
      var iAttr = link.getAttribute('data-thumb-index');
      if (iAttr !== null) {
        var parsed = parseInt(iAttr, 10);
        if (!isNaN(parsed)) return parsed;
      }

      var thumb = link.closest('.productView-thumbnail');
      if(!thumb) return null;

      var thumbs = Array.from(thumbsWrap.querySelectorAll('.productView-thumbnail'));
      var idx = thumbs.indexOf(thumb);
      return idx >= 0 ? idx : null;
    }

    function activateFallback(i){
      slides.forEach(function(s,idx){
        s.style.display = (idx === i ? '' : 'none');
      });
    }

    function trySlick(i){
      if(!window.jQuery) return false;
      var $main = window.jQuery(main);
      if ($main.hasClass('slick-initialized')) { $main.slick('slickGoTo', i); return true; }
      return false;
    }

    function trySwiper(i){
      var sw = main.swiper;
      if(sw && sw.slideTo){ sw.slideTo(i); return true; }
      return false;
    }

    function tryFlickity(i){
      var flkty = main._flickity;
      if(!flkty && window.jQuery) flkty = window.jQuery(main).data('flickity');
      if(!flkty && window.Flickity && window.Flickity.data) flkty = window.Flickity.data(main);
      if(flkty && flkty.select){ flkty.select(i); return true; }
      return false;
    }

    root.addEventListener('click', function(e){
      var idx = getIndexFromClick(e.target);
      if(idx === null) return;

      e.preventDefault();

      // Intenta controlar el slider real si existe
      if(trySlick(idx) || trySwiper(idx) || tryFlickity(idx)) return;

      // Si no hay slider o no responde, fuerza el cambio
      activateFallback(idx);
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    // Busca cualquier galería de producto de Halo en la página
    document.querySelectorAll('.product-details').forEach(initGallery);
  });
})();
